import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoadingService } from '../../services/loading.service';
import { PermissionService } from '../../services/permission.service';

@Directive({
  selector: '[hasPermission]',
})
export default class HasPermissionDirective {
  subscription: Subscription;
  constructor(
    private permissionService: PermissionService,
    private loadingService: LoadingService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  @Input() set hasPermission(userAllowance: Array<any>) {
    const permission = { permission: userAllowance[0], tab: userAllowance[1] };

    const updateView = () => {
      if (this.permissionService.checkPermissionValue(permission)) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    };

    if (this.permissionService.checkPermissionValue(permission) === undefined) {
      this.subscription = this.loadingService.permissionLoadedEvent$.subscribe(() => {
        updateView();
        this.subscription.unsubscribe();
      });
    } else {
      updateView();
    }
  }
}
